import React from 'react';
import { Column } from 'react-table';
import { useTheme } from 'styled-components';

import { MODAL_TYPES, useGlobalModalContext } from '../../../../context/GlobalModal';
import { getMembers } from '../../../../services';
import { Button, Splash, TableComponent } from '../../../../shared/Components';
import { FlexContainer, Text } from '../../../../shared/Typhography';
import { strings } from '../../../../strings';

interface Data {
  name: string;
  username: string;
  role: string;
  email: string;
  action: () => void;
}

const UsersAndPermissionsScreen = () => {
  const { colors } = useTheme();
  const { data: membersData, isLoading } = getMembers();
  const { showModal } = useGlobalModalContext();

  const data = React.useMemo(
    () =>
      membersData?.docs.map((item) => ({
        name: item.data().Name,
        email: item.data().email,
        username: item.data().username,
        role: item.data().Role,
      })),
    [membersData],
  );

  const headers: Column<Data>[] = React.useMemo(
    () => [
      {
        Header: strings.name,
        accessor: 'name',
      },
      {
        Header: strings.email,
        accessor: 'email',
      },
      {
        Header: strings.nickname,
        accessor: 'username',
        Cell: (cell) => (
          <Text weight="bold" color={colors.purple}>
            {cell.row.original.username}
          </Text>
        ),
      },
      {
        Header: strings.role,
        accessor: 'role',
      },
    ],
    [membersData],
  );

  const addUser = () => {
    showModal(MODAL_TYPES.ADD_MEMBER_MODAL);
  };

  if (isLoading) {
    return <Splash />;
  }

  return (
    <FlexContainer width="75%" flexDirection="column" gap="2rem">
      <FlexContainer justifyContent="space-between" alignItems="center">
        <Text weight="bold" size={2.4}>
          {strings.usersAndPermissions}
        </Text>
        <Button onClick={addUser} width={160} height={40}>
          {strings.addMember}
        </Button>
      </FlexContainer>
      <TableComponent columns={headers} data={data} />
    </FlexContainer>
  );
};

export default UsersAndPermissionsScreen;
